export const genderOptions = [
  "Male",
  "Female",
  "Non-binary",
  "Undisclosed",
] as const;

export type Gender = typeof genderOptions[number];
